<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="signup-popup">
  <div class="signup-wrap d-md-flex" id="signup-wrap">
    <div class="signup-banner">
    </div>
    <div class="signup-fields">
      <a (click)="closecomponent()" class="close-btn cursorHand">
        <i class="icon-close"></i>
      </a>
      <div class="popup-logo text-center">
        <a href="/"><img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="logo"></a>
      </div>
      <h4 class="signup-title text-center">Create an account</h4>
      <div class="global-error">
        <div class="invalid-feedback text-center" style="display: block; margin-bottom:5px;position: static;"
          *ngIf="errorMessageEmail?.length > 0">
          {{ errorMessageEmail }}
        </div>
      </div>
      <form class="login-form" [formGroup]="registerFormUser" (ngSubmit)="onSubmitUserForm()">
        <div class="form-group">
          <input class="form-control" formControlName="firstName" type="text" placeholder="First Name*"
            [ngClass]="{ 'is-invalid': submitted && formData.firstName.errors }"
            onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
          <i class="icon-user"></i>
          <div *ngIf="submitted && formData.firstName.errors" class="invalid-feedback">
            <div *ngIf="formData.firstName.errors.required">
              Please enter your First name
            </div>
            <div *ngIf="formData.firstName.errors.minlength">
              Please enter atleast 3 charcaters.
            </div>
          </div>
        </div>
        <div class="form-group">
          <input class="form-control" type="text" formControlName="lastName" placeholder="Last Name*"
            [ngClass]="{ 'is-invalid': submitted && formData.lastName.errors }"
            onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
          <i class="icon-user"></i>
          <div *ngIf="submitted && formData.lastName.errors" class="invalid-feedback">
            <div *ngIf="formData.lastName.errors.required">
              Please enter your last name.
            </div>
            <div *ngIf="formData.lastName.errors.minlength">
              Please enter atleast 3 charcaters.
            </div>
          </div>
        </div>
        <div class="form-group">
          <input class="form-control" type="text" formControlName="email" placeholder="Email Address*"
            [ngClass]="{ 'is-invalid': submitted && formData.email.errors }">
          <i class="icon-email"></i>
          <div *ngIf="submitted && formData.email.errors" class="invalid-feedback">
            <div
              *ngIf="formData.email.errors.required || formData.email.errors.email || formData.email.errors.passwordValid">
              Please enter your email address in the format yourname@example.com</div>
          </div>
        </div>
        <div class="form-group">
          <input class="form-control" type="password" formControlName="password" placeholder="Password" id="pass"
            [ngClass]="{ 'is-invalid': submitted && formData.password.errors }"
            (keyup)="checkpasswordvalid($event.target.value);checkpassword()" (mouseenter)="showTooltip = true"
            (mouseleave)="showTooltip = false">
          <i class="icon-pwd"></i>
          <div *ngIf="submitted && formData.password.errors" class="invalid-feedback">
            <div *ngIf="formData.password.errors.required">Please enter a password</div>
          </div>
          <div class="invalid-feedback" style="display: block">
            {{passerr2}}
          </div>
          <div class="invalid-feedback" style="display: block" *ngIf="!passerr2 && false">
            {{ passwordSpecialCharcatersAllowed }}
          </div>
          <div class="invalid-feedback tipArrow" style="display: block" *ngIf="!passerr2 && showTooltip && false">
            {{ passwordSpecialCharcatersAllowed }}
          </div>
        </div>
        <div class="form-group">
          <input class="form-control" type="password" formControlName="conpassword" placeholder="Confirm Password"
            id='confirmpass' [ngClass]="{ 'is-invalid': submitted && formData.conpassword.errors }"
            (keyup)="checkpassword()">
          <i class="icon-pwd"></i>
          <div *ngIf="submitted && formData.conpassword.errors" class="invalid-feedback">
            <div *ngIf="formData.conpassword.errors.required">Please re-enter your password</div>
          </div>
          <div class="invalid-feedback" style="display: block" *ngIf="!confirmpass">Please check that your passwords
            match</div>
        </div>
        <p class="signup-terms">By signing up, I agree to MyLifeWell <a href="/terms-conditions">Terms of Service</a>,
          and <a href="/privacy_policy">Privacy</a>. </p>
        <div class="buttons-wrap">
          <button class="btn">Sign Up</button>
        </div>
        <p class="already-signup">Already a MyLifeWell.com member? <a (click)="closecomponentandlogin()">Log In</a> </p>
      </form>
    </div>
  </div>
</div>